import PropTypes from 'prop-types'
import { CalendarBlank, Info } from '@phosphor-icons/react'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import CheckboxField from '../../FormLegacy/FormFieldsV2/CheckboxField'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import Filter from '../../Filter/Filter'

import Box from './Box'
import Stars from './Stars'
import { getPeriodOptions, handleCheckboxChange } from './helpers'

const Filters = ({
  setPeriod = () => {},
  setNotReplied = () => {},
  setImmediateResponse = () => {},
  setPlatforms = () => {},
  setRatings = () => {},
  setSearchValue = () => {},
  period,
  notReplied,
  immediateResponse,
  platforms,
  ratings,
  searchValue,
}) => {
  const { t } = useTranslation(['organisation'])
  const periodOptions = getPeriodOptions(t)
  return (
    <div className="reputation-reviews-tab__filters-wrap">
      <Box
        title={t('organisation:reputationManagement.filters.title')}
        content={
          <div className="reputation-reviews-tab__filters">
            <TextField
              label={t('organisation:reputationManagement.filters.keywordLabel')}
              name="search"
              placeholder={t('organisation:reputationManagement.filters.searchPlaceholder')}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              additionalClass="reputation-reviews-tab__filters--search"
            />
            <div className="reputation-management-page__box-divider" />
            <CheckboxField
              onChange={() => setNotReplied((prev) => !prev)}
              value={notReplied}
              name="notReplied"
              label={t('organisation:reputationManagement.filters.havenTRepliedLabel')}
            />
            <div className="reputation-reviews-tab__tooltip-wrap">
              <CheckboxField
                onChange={() => setImmediateResponse((prev) => !prev)}
                value={immediateResponse}
                name="immediateResponse"
                label={t('organisation:reputationManagement.filters.immediateResponseLabel')}
              />
              <Info data-tip data-for="immediate-response-tip" size={20} />
              <ReactTooltip id="immediate-response-tip" place="top" effect="solid">
                {t('organisation:reputationManagement.filters.immediateResponseTooltip')}
              </ReactTooltip>
            </div>
            <div className="reputation-management-page__box-divider" />
            <div className="field">
              <label className="label">
                {t('organisation:reputationManagement.platformsTitle')}
              </label>
              {platforms.map((item, index) => (
                <CheckboxField
                  key={index}
                  onChange={() => handleCheckboxChange(index, setPlatforms)}
                  value={item.checked}
                  name={`platform-${item.label}`}
                  label={item.label}
                />
              ))}
            </div>
            <div className="reputation-management-page__box-divider" />
            <div className="field">
              <label className="label">
                {t('organisation:reputationManagement.filters.ratingLabel')}
              </label>
              {ratings.map((item, index) => (
                <CheckboxField
                  key={index}
                  onChange={() => handleCheckboxChange(index, setRatings)}
                  value={item.checked}
                  name={`rating-${item.label}`}
                  label={
                    index === 0 ? item.label : <Stars starsValue={0} starsTotal={+item.label} />
                  }
                />
              ))}
            </div>
            <div className="reputation-management-page__box-divider" />
            <Filter
              label={t('organisation:reputationManagement.filters.dateRangeLabel')}
              placeholder={
                <div className="reputation-dashboard-tab__filter-placeholder">
                  <CalendarBlank size={20} />
                  {period.text}
                </div>
              }
              options={periodOptions}
              value={[period]}
              name={'period'}
              additionalClass={'field'}
              onChange={(e) => setPeriod(e.target.value)}
              closeAfterSelect
            />
          </div>
        }
      />
    </div>
  )
}

Filters.propTypes = {
  setPeriod: PropTypes.func,
  setNotReplied: PropTypes.func,
  setImmediateResponse: PropTypes.func,
  setPlatforms: PropTypes.func,
  setRatings: PropTypes.func,
  setSearchValue: PropTypes.func,
  period: PropTypes.object,
  notReplied: PropTypes.bool,
  immediateResponse: PropTypes.bool,
  platforms: PropTypes.array,
  ratings: PropTypes.array,
  searchValue: PropTypes.string,
}

export default Filters
